document.addEventListener('DOMContentLoaded', function() {

  /* ---- HERO SLIDER ---- */
  (function() {
    var slides = document.querySelectorAll('.agd-hero-slide');
    var dots   = document.querySelectorAll('.agd-hero-dot');
    var current = 0;
    var timer;

    function goTo(n) {
      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current].classList.add('active');
    }

    function autoPlay() {
      timer = setInterval(function() { goTo(current + 1); }, 5000);
    }

    document.querySelector('.agd-hero-prev') &&
      document.querySelector('.agd-hero-prev').addEventListener('click', function() {
        clearInterval(timer); goTo(current - 1); autoPlay();
      });

    document.querySelector('.agd-hero-next') &&
      document.querySelector('.agd-hero-next').addEventListener('click', function() {
        clearInterval(timer); goTo(current + 1); autoPlay();
      });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        clearInterval(timer);
        goTo(parseInt(this.dataset.index));
        autoPlay();
      });
    });

    autoPlay();
  })();

  /* ---- COLLECTIONS SLIDER ---- */
  (function() {
    var track   = document.querySelector('.agd-collections-track');
    var slides  = document.querySelectorAll('.agd-coll-slide');
    var current = 0;
    if (!track || slides.length === 0) return;

    function update() {
      var w = slides[0].offsetWidth + 20;
      track.style.transform = 'translateX(-' + (current * w) + 'px)';
    }

    document.getElementById('agdCollPrev') &&
      document.getElementById('agdCollPrev').addEventListener('click', function() {
        current = (current - 1 + slides.length) % slides.length;
        update();
      });

    document.getElementById('agdCollNext') &&
      document.getElementById('agdCollNext').addEventListener('click', function() {
        current = (current + 1) % slides.length;
        update();
      });
  })();

  /* ---- CATEGORY SLIDER ---- */
  (function() {
    var track   = document.getElementById('agdCatTrack');
    var items   = document.querySelectorAll('.agd-cat-item');
    var current = 0;
    var visible = window.innerWidth < 480 ? 2 : window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 4 : 6;
    if (!track || items.length === 0) return;

    function update() {
      var w = items[0].offsetWidth + 16;
      track.style.transform = 'translateX(-' + (current * w) + 'px)';
    }

    document.getElementById('agdCatPrev') &&
      document.getElementById('agdCatPrev').addEventListener('click', function() {
        if (current > 0) { current--; update(); }
      });

    document.getElementById('agdCatNext') &&
      document.getElementById('agdCatNext').addEventListener('click', function() {
        if (current < items.length - visible) { current++; update(); }
      });
  })();

  /* ---- SPLIT SLIDER ---- */
  (function() {
    var imgSlides  = document.querySelectorAll('.agd-split-slide');
    var txtSlides  = document.querySelectorAll('.agd-split-text-slide');
    var dots       = document.querySelectorAll('.agd-split-dot');
    var current    = 0;
    var timer;

    function goTo(n) {
      imgSlides[current].classList.remove('active');
      txtSlides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = (n + imgSlides.length) % imgSlides.length;
      imgSlides[current].classList.add('active');
      txtSlides[current].classList.add('active');
      dots[current].classList.add('active');
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        clearInterval(timer);
        goTo(parseInt(this.dataset.index));
        timer = setInterval(function() { goTo(current + 1); }, 5000);
      });
    });

    timer = setInterval(function() { goTo(current + 1); }, 5000);
  })();

  /* ---- STORE SLIDER ---- */
  (function() {
    var slides  = document.querySelectorAll('.agd-store-slide');
    var current = 0;
    if (slides.length === 0) return;

    function goTo(n) {
      slides[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
    }

    document.getElementById('agdStorePrev') &&
      document.getElementById('agdStorePrev').addEventListener('click', function() { goTo(current - 1); });

    document.getElementById('agdStoreNext') &&
      document.getElementById('agdStoreNext').addEventListener('click', function() { goTo(current + 1); });
  })();

  /* ---- SCROLL TO TOP ---- */
  var goTop = document.getElementById('agd-go-top');
  if (goTop) {
    window.addEventListener('scroll', function() {
      goTop.classList.toggle('visible', window.scrollY > 400);
    });
    goTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

});